import { forwardRef } from "react";
import "intl-tel-input/build/css/intlTelInput.css";
import IntlTelInput from "intl-tel-input/react/build/IntlTelInput.esm";
import "../../node_modules/intl-tel-input/build/js/utils";
import { useProductData } from "@/zustand/productStore";
import { useTemplateStore } from "@/zustand/templateStore.js";
import s from "@/components/Inputs/Input.module.scss";
import cn from "@/utils/classNames.js";

const PhoneField = forwardRef(({ handleChange, error, value }, ref) => {
  const searchLabel = window.post_template?.checkout_v6_form.checkout_v6_formLabels?.tr_checkout_v6_form_searchLabel;
  const phoneLabel = window.post_template?.checkout_v6_form.checkout_v6_formLabels?.tr_checkout_v6_form_phoneLabel;
  const { country_code } = useProductData();
  const isEnhancedContrast = useTemplateStore((state) => state.enhancedContrast);

  if (country_code) {
    const initOptions = {
      initialCountry: country_code,
      showSelectedDialCode: true,
      nationalMode: false,
      countrySearch: true,
      i18n: {
        searchPlaceholder: searchLabel,
      },
      containerClass: isEnhancedContrast && "enhancedContrast" ? "iti_enhancedContrast" : "",
    };

    if (phoneLabel) {
      initOptions.customPlaceholder = () => phoneLabel;
    } else {
      initOptions.autoPlaceholder = "aggressive";
    }

    return (
      <div className={s.inputContainer} style={{ width: "100%", height: "100%" }} ref={ref}>
        <div
          className={cn(
            s.input,
            s.input__text,
            error && s.input__error,
            isEnhancedContrast && s.enhancedContrast,
            isEnhancedContrast && error && s.enhancedContrast__error
          )}
          style={{ padding: "0px" }}
        >
          <IntlTelInput
            id="phone"
            initialValue={value}
            onChangeNumber={(value) => {
              handleChange(value);
            }}
            autoComplete={"tel"}
            initOptions={initOptions}
          />
        </div>
        {error && <div className="formError">{error}</div>}
      </div>
    );
  }

  return null;
});

export default PhoneField;
